import { render, staticRenderFns } from "./TeacherAttendanceDashboardModal.vue?vue&type=template&id=72f52a28&scoped=true&"
import script from "./TeacherAttendanceDashboardModal.vue?vue&type=script&lang=js&"
export * from "./TeacherAttendanceDashboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f52a28",
  null
  
)

export default component.exports